import { gql } from '@apollo/client'

/* eslint-disable import/prefer-default-export */
export const CREATE_EVENT_LOG = gql`
  mutation EventLog(
    $input: EventLogInput!
  ) {
    eventLog(input: $input) {
      success
      message
    }
  }
`
